import React, { ComponentProps } from 'react';

import { DefaultView, Views } from '../../types/BlockWithViews';
import { NavigationPropertiesDefaultView } from './views/NavigationPropertiesDefaultView';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';

type NavigationPropertiesProps = Views<DefaultView<NavigationPropertiesDefaultView>>;
function NavigationProperties({ views }: NavigationPropertiesProps) {
  return <NavigationPropertiesDefaultView {...views.default} />;
}

export const NavigationPropertiesBlock = asFetchableBlock(NavigationProperties, BlockType.navigationproperties);
export type NavigationPropertiesBlock = ComponentProps<typeof NavigationPropertiesBlock>;
